import type { SupportedCountry } from "@/constants/country";
import { useAuthStore } from "@/lib/auth";
import { mapLocaleToCountryCode } from "@/lib/i18n/core/localeToCountryMap";

export function useDefaultCountryCode(): SupportedCountry {
  const { session } = useAuthStore();
  const primaryLocale = session?.organization?.primaryLocale ?? null;

  return mapLocaleToCountryCode(primaryLocale);
}
